import { apiClient } from "../../../lib";

class MaterialReqService {

    async getMaterialReqs(params: Record<string, any>) {
        const response = await apiClient.get("/material-request", { params });
        return response.data;
    };

    async getMaterialReqById({ projectId, requestId }: { projectId: string | undefined, requestId: string | null }) {
        const response = await apiClient.get(`/material-request/${requestId}`);
        return response.data;
    };

    async createMaterialReq(data: any) {
        const response = await apiClient.post("/material-request", data);
        return response.data;
    };

    async updateMaterialReq(id: string, data: any) {
        const response = await apiClient.put(`/material-request/${id}`, data);
        return response.data;
    };

    async deleteMaterialReq(id: string) {
        const response = await apiClient.delete(`/material-request/${id}`);
        return response.data;
    };

    async getActivitys(projectId: string | undefined, phaseId: string) {
        const response = await apiClient.get(`/projects/${projectId}/activities`, { params: { parent_id: phaseId } });
        return response.data;
    };

};

export const materialReqService = new MaterialReqService();
export default materialReqService;